import { render, staticRenderFns } from "./xy-modal-container-design.vue?vue&type=template&id=0f4dce8d"
import script from "./xy-modal-container-design.vue?vue&type=script&lang=js"
export * from "./xy-modal-container-design.vue?vue&type=script&lang=js"
import style0 from "./xy-modal-container-design.vue?vue&type=style&index=0&id=0f4dce8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports